import { jsx } from 'react/jsx-runtime';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import '../ui/badge.js';
import 'lucide-react';
import 'react';
import 'react-day-picker';
import '../ui/button.js';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import './FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

/**
 * Container for page-level action buttons
 * @param children - Action buttons or elements
 * @param className - Additional CSS classes
 * @param align - Alignment of actions
 * @param stack - Whether to stack actions vertically on mobile
 * @returns JSX element with action layout
 */
const PageActions = ({ children, className, align = 'right', stack = true, }) => {
    const alignClasses = {
        left: 'justify-start',
        right: 'justify-end',
        center: 'justify-center',
        between: 'justify-between',
    };
    // Make alignment responsive when stacking and right-aligned
    const getAlignClasses = () => {
        if (stack && align === 'right') {
            return 'justify-start lg:justify-end';
        }
        return alignClasses[align];
    };
    return (jsx("div", { className: cn('flex gap-3 w-full lg:w-auto', stack && 'flex-col sm:flex-row [&>*]:flex [&>*]:w-full [&>*]:sm:inline-flex [&>*]:sm:w-auto', !stack && 'flex-row', getAlignClasses(), className), children: children }));
};

export { PageActions };
//# sourceMappingURL=PageActions.js.map
